import React from 'react';
import SelectableButtonPanel from './SelectableButtonPanel';
import SelectableDiv from './SelectableDiv';

type SelectableProps = {
    onClicked: (selected: boolean) => void;
    id: string;
    selected: boolean;
    hasSelectableButton?: boolean;
    buttonText?: string;
    style?: React.CSSProperties;
    children?: React.ReactNode;
};

const Selectable = React.memo(SelectableMemo, (prevProps, currentProps) => {
    return (
        prevProps.selected === currentProps.selected &&
        prevProps.buttonText === currentProps.buttonText
    );
});

function SelectableMemo({
    onClicked,
    id,
    selected,
    style,
    hasSelectableButton,
    buttonText,
    children
}: SelectableProps): JSX.Element {
    if (hasSelectableButton === true) {
        return (
            <SelectableButtonPanel
                id={id}
                onClicked={onClicked}
                selected={selected}
                style={style}
                buttonText={buttonText}>
                {children}
            </SelectableButtonPanel>
        );
    } else {
        return (
            <SelectableDiv
                id={id}
                onClicked={onClicked}
                selected={selected}
                style={style}>
                {children}
            </SelectableDiv>
        );
    }
}

export default Selectable;
